import React, { useRef, useState, useEffect } from "react";
import { Button } from "@public/ui-toolkit";
// import { useHistory } from "react-router-dom";
import { Uploader } from "..";
import { getPost } from "../../../hedgefund-portal/src/containers/NewsFeed/actions";
import { useSelector, useDispatch } from "react-redux";

const CreatePost = ({
  loading,
  onSubmitNewPostHandler,
  message,
  getPostDetails,
  type = false,
  recordId,
}) => {
  // let history = useHistory();
  const dispatch = useDispatch();

  const [fileState, setFileState] = useState([]);
  const [deleteRecord, setDeleteRecord] = useState([]);

  const [filesData, setFilesData] = useState();
  const getNewPostState = useSelector((state) => state.getNewPosts);
  const { postCount, pageCount } = getNewPostState;

  useEffect(() => {
    if (message && message) {
      dispatch(
        getPost({
          page: pageCount,
          perPage: postCount,
        })
      );
    }
  }, [message && message]);

  useEffect(() => {
    if (getPostDetails?.records) {
      const list = getPostDetails?.records;
      setFilesData(list);
    }
  }, [getPostDetails?.records]);
  const descriptionRef = useRef("");

  const onSubmitHandler = (e) => {
    setFileState(e.target.files);

    const description = descriptionRef?.current?.value;
    const formData = new FormData();

    for (let i = 0; i < fileState?.length; i++) {
      formData.append(`Files`, fileState[i].file);
    }

    formData.append(`Description`, description);

    if (recordId) {
      formData.append(`id`, recordId);
      for (let i = 0; i < deleteRecord?.length; i++) {
        formData.append(`DeletedRecordIds`, deleteRecord[i]);
      }
    }
    onSubmitNewPostHandler(formData);
  };

  const onFileChange = ({ meta, file }, allFiles, status) => {
    setFileState([...fileState, meta]);

    setFileState(status);
  };

  const handleRemoveItem = (id) => {
    const newItems = filesData.filter((item) => item.id !== id);
    setFilesData(newItems);
    setDeleteRecord([...deleteRecord, id]);
  };

  return (
    <main>
      <div className="main-inner">
        {/* {message && !loading ? (
          <CustomAlerts
            alertMessage={"Uploaded Successfully!"}
            type="success"
          />
        ) : (
          ""
        )} */}
        <div className="container mt-5">
          <div className="p-xxl-5 p-md-4 p-3 box-shadow bg-white rounded-large">
            <div className="text-center box-lg">
              <h4 className="stylish-title text-blue mb-5">Create Post</h4>
              <div className="row g-4">
                <div className="col-12">
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      id="description"
                      placeholder="Description"
                      rows="6"
                      onChange={(e) => e.target.value}
                      defaultValue={getPostDetails?.description}
                      ref={descriptionRef}
                    ></textarea>
                    <label for="description">Description</label>
                  </div>
                </div>
                {/* <div className="col-md-12">
                  <div className="file-field">
                    <div className="file-name">Choose a file</div>
                    <div className="file-uploading-btn">
                      <div className="file-uploading-btn-text">
                        <i className="fa fa-paperclip mr-1" aria-hidden="true"></i>
                        <u>Choose file</u>
                      </div>
                      <Input
                        id="multiplefiles"
                        type="file"
                        name="file[]"
                        onChange={onChangeFileHandler}
                        multiple
                      />
                    </div>
                  </div>
                </div> */}

                <Uploader
                  onFileChange={onFileChange}
                  getPostDetails={getPostDetails}
                  type={true}
                />
                {type === true ? (
                  <div className="row">
                    {filesData
                      ? filesData.map((u) => {
                          return (
                            <div className="col-2 delete-img mr-4">
                              <img src={u?.url} alt="" width={50} />
                              <span
                                className="fa fa-trash-o icon-delete"
                                onClick={() => handleRemoveItem(u.id)}
                              ></span>
                            </div>
                          );
                        })
                      : null}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mt-5 text-center">
                <Button
                  btnName="Save"
                  btnType="primary"
                  onClick={onSubmitHandler}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CreatePost;
